import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\AuditController::blockIp
* @see app/Http/Controllers/Admin/AuditController.php:552
* @route '/app/admin/audits/block-ip'
*/
export const blockIp = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: blockIp.url(options),
    method: 'post',
})

blockIp.definition = {
    methods: ["post"],
    url: '/app/admin/audits/block-ip',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AuditController::blockIp
* @see app/Http/Controllers/Admin/AuditController.php:552
* @route '/app/admin/audits/block-ip'
*/
blockIp.url = (options?: RouteQueryOptions) => {
    return blockIp.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AuditController::blockIp
* @see app/Http/Controllers/Admin/AuditController.php:552
* @route '/app/admin/audits/block-ip'
*/
blockIp.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: blockIp.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::blockIp
* @see app/Http/Controllers/Admin/AuditController.php:552
* @route '/app/admin/audits/block-ip'
*/
const blockIpForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: blockIp.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::blockIp
* @see app/Http/Controllers/Admin/AuditController.php:552
* @route '/app/admin/audits/block-ip'
*/
blockIpForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: blockIp.url(options),
    method: 'post',
})

blockIp.form = blockIpForm

/**
* @see \App\Http\Controllers\Admin\AuditController::revokeKey
* @see app/Http/Controllers/Admin/AuditController.php:575
* @route '/app/admin/audits/revoke-key/{creatorApiKey}'
*/
export const revokeKey = (args: { creatorApiKey: number | { id: number } } | [creatorApiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: revokeKey.url(args, options),
    method: 'post',
})

revokeKey.definition = {
    methods: ["post"],
    url: '/app/admin/audits/revoke-key/{creatorApiKey}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AuditController::revokeKey
* @see app/Http/Controllers/Admin/AuditController.php:575
* @route '/app/admin/audits/revoke-key/{creatorApiKey}'
*/
revokeKey.url = (args: { creatorApiKey: number | { id: number } } | [creatorApiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { creatorApiKey: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { creatorApiKey: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            creatorApiKey: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creatorApiKey: typeof args.creatorApiKey === 'object'
        ? args.creatorApiKey.id
        : args.creatorApiKey,
    }

    return revokeKey.definition.url
            .replace('{creatorApiKey}', parsedArgs.creatorApiKey.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AuditController::revokeKey
* @see app/Http/Controllers/Admin/AuditController.php:575
* @route '/app/admin/audits/revoke-key/{creatorApiKey}'
*/
revokeKey.post = (args: { creatorApiKey: number | { id: number } } | [creatorApiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: revokeKey.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::revokeKey
* @see app/Http/Controllers/Admin/AuditController.php:575
* @route '/app/admin/audits/revoke-key/{creatorApiKey}'
*/
const revokeKeyForm = (args: { creatorApiKey: number | { id: number } } | [creatorApiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: revokeKey.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::revokeKey
* @see app/Http/Controllers/Admin/AuditController.php:575
* @route '/app/admin/audits/revoke-key/{creatorApiKey}'
*/
revokeKeyForm.post = (args: { creatorApiKey: number | { id: number } } | [creatorApiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: revokeKey.url(args, options),
    method: 'post',
})

revokeKey.form = revokeKeyForm

/**
* @see \App\Http\Controllers\Admin\AuditController::blockCreator
* @see app/Http/Controllers/Admin/AuditController.php:587
* @route '/app/admin/audits/block-creator/{creatorProfile}'
*/
export const blockCreator = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: blockCreator.url(args, options),
    method: 'post',
})

blockCreator.definition = {
    methods: ["post"],
    url: '/app/admin/audits/block-creator/{creatorProfile}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AuditController::blockCreator
* @see app/Http/Controllers/Admin/AuditController.php:587
* @route '/app/admin/audits/block-creator/{creatorProfile}'
*/
blockCreator.url = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { creatorProfile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { creatorProfile: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            creatorProfile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creatorProfile: typeof args.creatorProfile === 'object'
        ? args.creatorProfile.uuid
        : args.creatorProfile,
    }

    return blockCreator.definition.url
            .replace('{creatorProfile}', parsedArgs.creatorProfile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AuditController::blockCreator
* @see app/Http/Controllers/Admin/AuditController.php:587
* @route '/app/admin/audits/block-creator/{creatorProfile}'
*/
blockCreator.post = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: blockCreator.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::blockCreator
* @see app/Http/Controllers/Admin/AuditController.php:587
* @route '/app/admin/audits/block-creator/{creatorProfile}'
*/
const blockCreatorForm = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: blockCreator.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::blockCreator
* @see app/Http/Controllers/Admin/AuditController.php:587
* @route '/app/admin/audits/block-creator/{creatorProfile}'
*/
blockCreatorForm.post = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: blockCreator.url(args, options),
    method: 'post',
})

blockCreator.form = blockCreatorForm

/**
* @see \App\Http\Controllers\Admin\AuditController::unblockCreator
* @see app/Http/Controllers/Admin/AuditController.php:598
* @route '/app/admin/audits/unblock-creator/{creatorProfile}'
*/
export const unblockCreator = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: unblockCreator.url(args, options),
    method: 'delete',
})

unblockCreator.definition = {
    methods: ["delete"],
    url: '/app/admin/audits/unblock-creator/{creatorProfile}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\AuditController::unblockCreator
* @see app/Http/Controllers/Admin/AuditController.php:598
* @route '/app/admin/audits/unblock-creator/{creatorProfile}'
*/
unblockCreator.url = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { creatorProfile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { creatorProfile: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            creatorProfile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creatorProfile: typeof args.creatorProfile === 'object'
        ? args.creatorProfile.uuid
        : args.creatorProfile,
    }

    return unblockCreator.definition.url
            .replace('{creatorProfile}', parsedArgs.creatorProfile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AuditController::unblockCreator
* @see app/Http/Controllers/Admin/AuditController.php:598
* @route '/app/admin/audits/unblock-creator/{creatorProfile}'
*/
unblockCreator.delete = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: unblockCreator.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::unblockCreator
* @see app/Http/Controllers/Admin/AuditController.php:598
* @route '/app/admin/audits/unblock-creator/{creatorProfile}'
*/
const unblockCreatorForm = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unblockCreator.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::unblockCreator
* @see app/Http/Controllers/Admin/AuditController.php:598
* @route '/app/admin/audits/unblock-creator/{creatorProfile}'
*/
unblockCreatorForm.delete = (args: { creatorProfile: string | { uuid: string } } | [creatorProfile: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unblockCreator.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

unblockCreator.form = unblockCreatorForm

const audits = {
    blockIp: Object.assign(blockIp, blockIp),
    revokeKey: Object.assign(revokeKey, revokeKey),
    blockCreator: Object.assign(blockCreator, blockCreator),
    unblockCreator: Object.assign(unblockCreator, unblockCreator),
}

export default audits